import React from "react";
import "./SourcingServices.css";
import { FaHandshake, FaUsers, FaCheckCircle, FaSearch, FaBox, FaShip, FaIndustry, FaCouch, FaTshirt, FaGem, FaUtensils, FaBoxOpen } from "react-icons/fa";
import productimg01 from "../../assets/Images/product-img01.jpg";
import productimg02 from "../../assets/Images/product-img02.png";
import { NavLink } from "react-router-dom";


const whyChooseUs = [
  { icon: <FaSearch />, text: "Expert in Sourcing Almost Any Product" },
  { icon: <FaHandshake />, text: "Better Prices with Local Negotiation Power" },
  { icon: <FaUsers />, text: "Verified & Trusted Suppliers Only" },
  { icon: <FaCheckCircle />, text: "Quality Inspection & Testing Before Shipment" },
  { icon: <FaBox />, text: "Consolidated Samples from Multiple Suppliers" },
  { icon: <FaShip />, text: "Full Export & Logistics Support" }
];

const howItWorks = [
  { step: "1", title: "Tell Us What You Need", desc: "Share your product details and requirements." },
  { step: "2", title: "We Find the Best Suppliers", desc: "Negotiating on your behalf for best prices." },
  { step: "3", title: "Quality & Sample Consolidation", desc: "Multiple supplier samples in one shipment." },
  { step: "4", title: "Export & Delivery", desc: "End-to-end support until it reaches your warehouse." }
];

const industries = [
  { icon: <FaTshirt />, name: "Home Textiles (Bedsheets, Towels, Curtains)" },
  { icon: <FaUtensils />, name: "Food & Beverages (Milk Powder, Spices, Pulses)" },
  { icon: <FaIndustry />, name: "Industrial Products" },
  { icon: <FaBoxOpen />, name: "Packaging Materials" },
  { icon: <FaGem />, name: "Apparel & Fashion Accessories" }
];

const promises = [
  "100% Supplier Verification",
  "Pre-Shipment Quality Inspection",
  "Transparent Pricing",
  "No Hidden Costs"
];

const testimonials = [
  {
    name: "John D.",
    review: "INDVO helped me source high-quality textiles at nearly 20% cheaper than my usual suppliers. Their inspection reporting is rock solid!"
  },
  {
    name: "Sarah L.",
    review: "Sample consolidation saved me weeks of waiting. I could compare multiple suppliers in one shipment. Highly trustable team!"
  }
];

const SourcingServices = () => {
  return (
    <section className="services-wrapper">

      {/* HERO SECTION */}
      <div className="services-hero">
        <div className="overlay"></div>
        <div className="hero-content">
          <h1>Your Trusted Partner for Sourcing from India — Quality, Pricing & Protection Guaranteed</h1>
          <p>We connect you directly with verified Indian suppliers, inspect products, and consolidate samples so you can compare quality before you buy.</p>
           <button className="cta-btn">
  <NavLink to="/SourcingRequestForm">
    Send Your Requirements
  </NavLink>
</button>
         
          
        </div>
      </div>

      {/* WHY CHOOSE US */}
      <section className="why-choose-us">
        <h2>Why Choose Us</h2>
        <div className="why-grid">
          {whyChooseUs.map((item, index) => (
            <div key={index} className="why-card">
              <div className="icon">{item.icon}</div>
              <p>{item.text}</p>
            </div>
          ))}
        </div>
      </section>

      {/* HOW IT WORKS */}
      <section className="how-it-works">
        <h2>How It Works</h2>
        <div className="steps">
          {howItWorks.map((step, index) => (
            <div key={index} className="step-card">
              <div className="step-number">{step.step}</div>
              <h4>{step.title}</h4>
              <p>{step.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* INDUSTRIES & PRODUCTS */}
      <section className="industries">
        <h2>Industries & Products We Source</h2>
        <div className="industries-grid">
          {industries.map((industry, i) => (
            <div key={i} className="industry-card">
              {industry.icon}
              <span>{industry.name}</span>
            </div>
          ))}
        </div>
      </section>

      {/* CLIENT PROTECTION PROMISE */}
      <section className="promise">
        <h2>Our Client Protection Promise</h2>
        <ul>
          {promises.map((p, i) => (
            <li key={i}><FaCheckCircle /> {p}</li>
          ))}
        </ul>
      </section>

      {/* TESTIMONIALS */}
      <section className="testimonials">
        <h2>What Our Clients Say</h2>
        <div className="testimonial-grid">
          {testimonials.map((t, i) => (
            <div key={i} className="testimonial-card">
              <p>“{t.review}”</p>
              <h5>- {t.name}</h5>
            </div>
          ))}
        </div>
      </section>

      {/* FINAL CTA */}
      <section className="final-cta">
        <h2>Ready to Source from India with Confidence?</h2>
        <button className="cta-btn">Send Your Requirements</button>
      </section>

    </section>
  );
};

export default SourcingServices;
